﻿(function () {
  /**
   * 初始化单个首页轮播区块（绑定 #ug-index-section-slides_{{ section.id }}）
   */
  function initUgIndexSlidesInstance(swiperElement) {
    if (!swiperElement || swiperElement.dataset.ugIndexSlidesInit === 'true') return;
    if (typeof Swiper === 'undefined') return;

    swiperElement.dataset.ugIndexSlidesInit = 'true';

    let autoplayTimer = null;
    let progressAnimationFrame = null;
    let slideNextTimer = null;
    let currentVideoElement = null;
    let videoProgressListener = null;
    let videoEndedListener = null;
    let isTransitioning = false;
    let isPaused = false;
    let lastRealIndex = 0;

    const paginationPoints = swiperElement.querySelectorAll(
      '.ug-index-section-slides__point-list__inner'
    );
    const paginationTexts = swiperElement.querySelectorAll(
      '.ug-index-section-slides__pagination__point__text'
    );
    const paginationProgressBars = swiperElement.querySelectorAll(
      '.ug-index-section-slides__pagination__point__progress'
    );
    const pointListElement = swiperElement.querySelector('.ug-index-section-slides__point-list');
    const nextBtn = swiperElement.querySelector('.ug-index-section-slides__nav-btn--next');
    const prevBtn = swiperElement.querySelector('.ug-index-section-slides__nav-btn--prev');

    document.addEventListener('visibilitychange', function onVisibilityChange() {
      if (document.hidden) {
        isPaused = true;
        stopAutoplay();
        swiperElement.querySelectorAll('ug-video-player').forEach((player) => {
          if (player && player.pauseVideo) {
            player.pauseVideo();
          }
        });
      } else {
        isPaused = false;
        isTransitioning = false;
        if (swiper) {
          startAutoplay(swiper);
          const activeSlide = swiper.slides[swiper.activeIndex];
          if (activeSlide) {
            const videoPlayer = activeSlide.querySelector('ug-video-player');
            if (videoPlayer && activeSlide.classList.contains('video-slide')) {
              videoPlayer.playVideo();
            }
          }
        }
      }
    });

    const swiper = new Swiper(swiperElement, {
      slidesPerView: 1,
      loop: true,
      spaceBetween: 0,
      effect: 'slide',
      autoplay: false,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
      on: {
        init: function () {
          swiperElement.classList.add('is-initialized');

          setTimeout(() => {
            paginationTexts.forEach((text) => {
              text.classList.add('animated-text');
            });
          }, 2000);

          initPaginationClicks(this);
          updatePaginationState(this.realIndex);
          lastRealIndex = this.realIndex;

          const firstSlide = this.slides[this.activeIndex];
          if (firstSlide) {
            const videoPlayer = firstSlide.querySelector('ug-video-player');
            if (videoPlayer && firstSlide.classList.contains('video-slide')) {
              videoPlayer.loadVideo();
              prepareVideoElement(videoPlayer);
              setTimeout(() => {
                videoPlayer.playVideo();
                setTimeout(() => {
                  startAutoplay(this);
                }, 100);
              }, 300);
            } else {
              startAutoplay(this);
            }
          }
        },
        slideChange: function () {
          /* 无论是否同 realIndex，都清掉切页锁，避免 loop 边界卡住后续点击/自动播 */
          isTransitioning = false;

          if (this.realIndex === lastRealIndex) {
            return;
          }

          lastRealIndex = this.realIndex;
          stopAutoplay();
          updatePaginationState(this.realIndex);

          const activeSlide = this.slides[this.activeIndex];

          swiperElement.querySelectorAll('ug-video-player').forEach((player) => {
            if (player && player.reset) {
              player.reset();
            }
          });

          if (activeSlide) {
            const videoPlayer = activeSlide.querySelector('ug-video-player');
            if (videoPlayer && activeSlide.classList.contains('video-slide')) {
              videoPlayer.loadVideo();
              prepareVideoElement(videoPlayer);
              setTimeout(() => {
                videoPlayer.playVideo();
                setTimeout(() => {
                  startAutoplay(this);
                }, 100);
              }, 300);
            } else {
              startAutoplay(this);
            }
          }
        },
      },
      breakpoints: {
        768: {
          allowTouchMove: false,
        },
        320: {
          allowTouchMove: true,
          touchRatio: 1,
        },
      },
      touchRatio: 1,
      touchAngle: 45,
      threshold: 5,
    });

    function prepareVideoElement(videoPlayer) {
      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      let videoElement = isMobile
        ? videoPlayer.querySelector('.ug-video__element--mobile video')
        : videoPlayer.querySelector('.ug-video__element--desktop video');

      if (!videoElement && isMobile) {
        videoElement = videoPlayer.querySelector('.ug-video__element--desktop video');
      } else if (!videoElement && !isMobile) {
        videoElement = videoPlayer.querySelector('.ug-video__element--mobile video');
      }

      if (videoElement) {
        videoElement.muted = true;
      }
    }

    function initPaginationClicks(swiperInstance) {
      paginationPoints.forEach((point, index) => {
        point.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();

          /* 先停自动播：点当前项若不停，进度条走完会立刻 slideNext，表现为「点当前却切下一张」 */
          stopAutoplay();
          isTransitioning = false;

          if (index === swiperInstance.realIndex) {
            const bar = paginationProgressBars[index];
            if (bar) {
              bar.style.transition = 'none';
              bar.style.width = '0%';
              void bar.offsetWidth;
              bar.style.transition = '';
            }
            startAutoplay(swiperInstance);
            return;
          }

          if (typeof swiperInstance.slideToLoop === 'function') {
            swiperInstance.slideToLoop(index);
          } else {
            swiperInstance.slideTo(index);
          }
        });
      });
    }

    function updatePaginationState(realIndex) {
      paginationTexts.forEach((text, index) => {
        if (index === realIndex) {
          text.classList.add('active');
        } else {
          text.classList.remove('active');
        }
      });

      const bars = paginationProgressBars;
      for (let i = 0; i < bars.length; i++) {
        bars[i].style.transition = 'none';
        bars[i].style.width = '0%';
      }
      if (bars.length > 0) {
        void bars[0].offsetWidth;
      }
      for (let i = 0; i < bars.length; i++) {
        bars[i].style.transition = '';
        if (i === realIndex) {
          bars[i].parentElement.classList.add('active');
        } else {
          bars[i].parentElement.classList.remove('active');
        }
      }

      if (pointListElement && paginationPoints[realIndex]) {
        const isDarkMode = paginationPoints[realIndex].dataset.darkMode === 'true';
        pointListElement.classList.toggle('is-dark-mode', isDarkMode);
        swiperElement.classList.toggle('is-dark-mode', isDarkMode);
      }
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        clearTimeout(autoplayTimer);
        autoplayTimer = null;
      }

      if (progressAnimationFrame) {
        cancelAnimationFrame(progressAnimationFrame);
        progressAnimationFrame = null;
      }

      if (slideNextTimer) {
        clearTimeout(slideNextTimer);
        slideNextTimer = null;
      }

      /* 取消待切页时必须解锁，否则 tab 切走/点分页后 isTransitioning 会卡死自动播 */
      isTransitioning = false;

      if (currentVideoElement) {
        if (videoProgressListener) {
          currentVideoElement.removeEventListener('timeupdate', videoProgressListener);
          videoProgressListener = null;
        }
        if (videoEndedListener) {
          currentVideoElement.removeEventListener('ended', videoEndedListener);
          videoEndedListener = null;
        }
        currentVideoElement = null;
      }
    }

    function scheduleSlideNext(swiperInstance, delayMs) {
      if (slideNextTimer) {
        clearTimeout(slideNextTimer);
        slideNextTimer = null;
      }
      slideNextTimer = setTimeout(() => {
        slideNextTimer = null;
        /* 隐藏/暂停时不切页且保持解锁；真正切页前再上锁，由 slideChange 解锁 */
        if (isPaused || document.hidden) {
          isTransitioning = false;
          return;
        }
        if (isTransitioning) return;
        isTransitioning = true;
        swiperInstance.slideNext();
      }, delayMs);
    }

    function startAutoplay(swiperInstance) {
      if (isPaused || document.hidden) return;

      const activeSlide = swiperInstance.slides[swiperInstance.activeIndex];
      const realIndex = swiperInstance.realIndex;
      const progressBar = paginationProgressBars[realIndex];

      if (!activeSlide || !progressBar) return;

      const videoPlayer = activeSlide.querySelector('ug-video-player');
      const isVideoSlide = activeSlide.classList.contains('video-slide');

      if (isVideoSlide && videoPlayer) {
        handleVideoAutoplay(swiperInstance, videoPlayer, progressBar);
      } else {
        handleImageAutoplay(swiperInstance, progressBar, 4000);
      }
    }

    function handleImageAutoplay(swiperInstance, progressBar, duration) {
      const startTime = Date.now();

      function updateProgress() {
        if (isPaused || document.hidden) {
          return;
        }

        const elapsed = Date.now() - startTime;
        const progress = Math.min(elapsed / duration, 1);

        progressBar.style.width = progress * 100 + '%';

        if (progress < 1) {
          progressAnimationFrame = requestAnimationFrame(updateProgress);
        } else if (!isTransitioning && !isPaused && !document.hidden) {
          isTransitioning = true;
          swiperInstance.slideNext();
        }
      }

      progressAnimationFrame = requestAnimationFrame(updateProgress);
    }

    function getVisibleVideoElement(videoPlayer) {
      const allVideos = videoPlayer.querySelectorAll('video');

      for (let video of allVideos) {
        const style = window.getComputedStyle(video);
        if (style.display !== 'none') {
          return video;
        }
      }

      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      let videoElement = null;

      if (isMobile) {
        videoElement = videoPlayer.querySelector('.ug-video__element--mobile video');
        if (!videoElement) {
          videoElement = videoPlayer.querySelector('.ug-video__element--desktop video');
        }
      } else {
        videoElement = videoPlayer.querySelector('.ug-video__element--desktop video');
        if (!videoElement) {
          videoElement = videoPlayer.querySelector('.ug-video__element--mobile video');
        }
      }

      return videoElement;
    }

    function handleVideoAutoplay(swiperInstance, videoPlayer, progressBar) {
      const videoElement = getVisibleVideoElement(videoPlayer);

      if (!videoElement) {
        return;
      }

      currentVideoElement = videoElement;
      videoElement.muted = true;

      const startVideoTracking = () => {
        videoProgressListener = function () {
          if (isPaused || document.hidden) {
            return;
          }
          const duration = videoElement.duration;
          const currentTime = videoElement.currentTime;

          if (duration && !isNaN(duration) && duration > 0) {
            const progress = currentTime / duration;
            progressBar.style.width = progress * 100 + '%';

            /* 用 slideNextTimer 防抖，预约阶段不上锁，避免定时器被清后锁死 */
            if (
              progress >= 0.99 &&
              !isTransitioning &&
              !slideNextTimer &&
              !isPaused &&
              !document.hidden
            ) {
              scheduleSlideNext(swiperInstance, 100);
            }
          }
        };

        videoElement.addEventListener('timeupdate', videoProgressListener);

        videoEndedListener = function () {
          if (!isTransitioning && !slideNextTimer && !isPaused && !document.hidden) {
            scheduleSlideNext(swiperInstance, 100);
          }
        };

        videoElement.addEventListener('ended', videoEndedListener, { once: true });
      };

      if (videoElement.readyState >= 1) {
        startVideoTracking();
      } else {
        videoElement.addEventListener('loadedmetadata', startVideoTracking, { once: true });
      }
    }
  }

  function initAllUgIndexSlides() {
    document.querySelectorAll('.ug-index-section-slides').forEach(initUgIndexSlidesInstance);
  }

  function runWhenSwiperReady() {
    if (typeof Swiper !== 'undefined') {
      initAllUgIndexSlides();
      return;
    }

    const checkSwiperLoaded = setInterval(() => {
      if (typeof Swiper !== 'undefined') {
        clearInterval(checkSwiperLoaded);
        initAllUgIndexSlides();
      }
    }, 100);

    setTimeout(() => clearInterval(checkSwiperLoaded), 10000);
  }

  function startHeroSlidesInit() {
    runWhenSwiperReady();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startHeroSlidesInit, { once: true });
  } else {
    startHeroSlidesInit();
  }
})();
